import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { NavigateLinks, LoaderBackdrop } from '@/components';

import { editServiceVisitTypeBreadcrumbs } from '../config';
import { ServiceVisitTypeForm } from '../components';
import { useUpdateServiceVisitType } from '../hooks';
import { useGetServiceVisitTypeByIdQuery } from '../services';
import { toServiceVisitTypeFormValues } from '../models';

const EditServiceVisitType = () => {
  const navigate = useNavigate();
  const { serviceVisitTypeId } = useParams<{ serviceVisitTypeId: string }>();

  if (!serviceVisitTypeId) {
    throw new Error('El ID del tipo de visita es requerido');
  }

  const {
    data: serviceVisitType,
    isLoading,
    error,
  } = useGetServiceVisitTypeByIdQuery({ id: serviceVisitTypeId });

  const { handleUpdate, isUpdating } = useUpdateServiceVisitType();

  const breadcrumbs = useMemo(
    () => editServiceVisitTypeBreadcrumbs(navigate),
    [navigate]
  );

  const initialValues = useMemo(
    () =>
      serviceVisitType
        ? toServiceVisitTypeFormValues(serviceVisitType)
        : undefined,
    [serviceVisitType]
  );

  if (isLoading) {
    return <LoaderBackdrop />;
  }

  if (error || !serviceVisitType) {
    return (
      <section className='flex flex-col gap-6 w-full h-full'>
        <NavigateLinks
          actualPage='Editar tipo de visita'
          breadcrumbs={breadcrumbs}
        />
        <div className='bg-red-50 border border-red-200 rounded-lg p-4'>
          <p className='text-red-800'>No se pudo cargar el tipo de visita.</p>
        </div>
      </section>
    );
  }

  return (
    <section className='flex flex-col gap-6 w-full h-full'>
      <NavigateLinks
        actualPage={`Editar tipo de visita: ${serviceVisitType.name}`}
        breadcrumbs={breadcrumbs}
      />
      <ServiceVisitTypeForm
        initialValues={initialValues}
        onSubmit={(values) => handleUpdate(serviceVisitTypeId, values)}
        isSubmitting={isUpdating}
        submitLabel='Guardar cambios'
      />
    </section>
  );
};

export default EditServiceVisitType;
